import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import {
  LanguagesLoad,
  LanguagesLoadError,
  LanguagesLoadSuccess,
  LANGUAGES_LOAD,
  LANGUAGES_LOAD_ERROR,
  LANGUAGES_LOAD_SUCCESS,
} from '../actions/languages.actions';
import { NotificationService } from '../../shared/services/notification.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { AppState } from '../reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class LanguageEffects {
  public languagesLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LanguagesLoad>(LANGUAGES_LOAD),
      tap(() => (this.notificationService.loading = true)),
      withLatestFrom(this.store.select(state => state.languages)),
      mergeMap(([action, storeLanguages]) => {
        if (storeLanguages === null) {
          return this.languageService.getLanguages().pipe(
            map(languages => new LanguagesLoadSuccess(languages)),
            catchError(() => of(new LanguagesLoadError()))
          );
        } else {
          return EMPTY;
        }
      })
    )
  );

  public languagesLoadSucces$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<LanguagesLoadSuccess>(LANGUAGES_LOAD_SUCCESS),
        tap(() => (this.notificationService.loading = false))
      ),
    { dispatch: false }
  );

  public languagesLoadError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<LanguagesLoadError>(LANGUAGES_LOAD_ERROR),
        tap(() => (this.notificationService.loading = false)),
        tap(() => this.notificationService.openSnackBar('error', 'COMMON.LANGUAGES_NOT_LOADED'))
      ),
    { dispatch: false }
  );

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private notificationService: NotificationService,
    private languageService: LanguageService
  ) {}
}
